
export interface MatchDay {
  id?: number;
  matchDayType: MatchDayType;
  roundId?: number;
  seasonId?: number;
  number?: number;
  name?: string;
  defaultDateTime?: Date;
  laczyNasPilkaUrl?: string;

  matches?: Match[];
}

export enum MatchType {
  None = 0,
  League = 1,
  Cup = 2,
  Friendly = 3,
}

export enum MatchDayType {
  None = 0,
  League = 1,
  Cup = 2,
  Friendly = 3,
}

export enum ScoreType {
  NoScore = 0,
  Classic = 1,
  Overtime = 2,
  Penalties = 3,
  Walkover = 4,
}

export enum EditMode {
  General = 'general',
  Score = 'score',
  Players = 'players',
  MatchEvents = 'matchEvents',
}

export interface Match {
  id?: number;
  roundId?: number;
  matchDayId?: number;
  matchType: MatchType;
  matchDateTime: Date;
  teamHomeId: number;
  teamHomeName: string;
  teamAwayId: number;
  teamAwayName: string;
  // score?: MatchScore;
  scoreType: ScoreType;
  homeTeamScore?: number;
  awayTeamScore?: number;
  halfHomeTeamScore?: number;
  halfAwayTeamScore?: number;
  report?: string;
}

export interface SaveMatchPayload {
  id?: number;
  matchDayId?: number;
  matchType: MatchType;
  matchDateTime: Date;
  teamHomeId: number;
  teamAwayId: number;
  scoreType: ScoreType;
  homeTeamScore?: number;
  awayTeamScore?: number;
  halfHomeTeamScore?: number;
  halfAwayTeamScore?: number;
  report?: string;
}

export interface MatchScore {
  scoreType: ScoreType;
  homeTeamScore?: number;
  awayTeamScore?: number;
  halfHomeTeamScore?: number;
  halfAwayTeamScore?: number;
}

export interface ScheduleState {
  matchDays: MatchDay[];
  matchDayIdForNewMatch?: number;
}

